import styles from './productSelectField.module.css'
import { O, Option, SelectField, Validatable, option } from '../../../../../features/ui'
import { TableName } from '../../../../../tables'
import { define } from '../../../../../utils/typeUtils'
import { useFind } from '../../../../../state/reducers/hooks'
import { Supplier } from '../../../../purchases'
import { Product } from '../../../state/types'
import { useProductHooks } from '../../../hooks/productHooks'
import { ProductName } from '../product-name/productName'
import { useStockHooks } from '../../../../stock'

type Props = {
    productList: Product[]
    branchId?: string
    defaultValue?: string
    showStock?: boolean
    focus?: boolean
    onChange: (productId?: string) => void
}

export const ProductSelectField = (props: Props) => {
    const { productList, branchId, defaultValue, showStock = true, focus, onChange } = props

    const { describeAvailableStock } = useStockHooks()
    const { searchProducts } = useProductHooks()
    const find = useFind()

    const options = productList.map(product => option(product.id, product.name))

    const searchProductsFn = (text?: string): Option[] => {
        return searchProducts(productList, text, true).map(product => option(product.id, product.name))
    }

    const renderInputLabel = (productId: string) => {
        const product = productList.find(product => product.id === productId)
        const supplier = find(TableName.SUPPLIERS, product?.supplierId) as O<Supplier>
        
        return product && supplier ? `${product.name} (${product.supplierCode}) - ${supplier.name}` : ''
    }

    const renderOption = async (
        option: Option,
        onClick?: (e: React.MouseEvent<HTMLElement>) => void
    ) => {
        const product = define(find(TableName.PRODUCTS, option.value)) as Product
        const stockInfo = showStock && branchId ? await describeAvailableStock(product, branchId) : undefined
        const stockClassName = `${styles.stock} ${stockInfo?.startsWith('0') ? styles.noStock : ''}`
        return (
            <div className={styles.option} onClick={onClick}>
                <ProductName product={product} showSupplierCode />
                {stockInfo && (
                    <span className={stockClassName}>
                        {stockInfo}
                    </span>
                )}
            </div>
        )
    }
    
    return (
        <Validatable validations={[]} left>
            <SelectField
                id="productId"
                defaultValue={defaultValue}
                options={options}
                placeholder="Seleccionar producto"
                focus={focus}
                searchFn={searchProductsFn}
                renderInputLabel={renderInputLabel}
                renderOption={renderOption}
                onChange={onChange}
            />
        </Validatable>
    )
}
